var StepStatus;
(function (StepStatus) {
    StepStatus["done"] = "done";
    StepStatus["active"] = "active";
    StepStatus["todo"] = "todo";
})(StepStatus || (StepStatus = {}));

export { StepStatus };
